export default __webpack_public_path__ + "be7cb18dc7caf47cf7e948341507713a.woff2";